module.exports = __webpack_public_path__ + "img/homescreen-ios.a19f8297.png";